{
  "en": "English",
  "fr": "Français",
  "de": "Deutsch (Deutschland)",
  "it": "Italiano",
  "ja": "日本語",
  "ko": "한국어",
  "pt": "Português (Brasil)",
  "es": "Español (España)",
  "bn": "বাংলা"
}
